import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';


@Service()
export class Api {
    private apiClient = inject(HttpClient);

    postData(data: any, endpoint:string) {
    return this.apiClient.post(`${environment.base}${endpoint}`, data,{ observe: 'response' } );
  }
}
